import { useEffect } from "react";
import { BRAND_CONFIGURATION } from "../../../../../configs/brands";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useOverlayStepsOrchestrator } from "../../useOverlayStepsOrchestrator";
import { useElapsed } from "../../../../utils/useElapsed";
const { airship } = BRAND_CONFIGURATION;
const KEY = "airship";
export const useInitAirship = () => {
    const { dispatch } = useOverlayOrchestrator();
    const canProceed = useOverlayStepsOrchestrator(KEY);
    const active = Boolean(airship && canProceed);
    const isElapsed = useElapsed({ active, duration: 15 });
    useEffect(() => {
        if (!airship && canProceed) {
            dispatch({ type: "DISABLE", payload: KEY });
        }
    }, [canProceed, dispatch]);
    useEffect(() => {
        if (isElapsed) {
            dispatch({ type: "INIT", payload: KEY });
        }
    }, [isElapsed, dispatch]);
};
